import React from 'react';
import { STORE_LOCATIONS } from '../services/storeHoursApiService.ts';
import './StoreHoursSelector.css';

interface StoreHoursSelectorProps {
  onSelectStore: (storeId: string, storeName: string) => void;
}

const StoreHoursSelector: React.FC<StoreHoursSelectorProps> = ({ onSelectStore }) => {
  return (
    <div className="store-hours-selector">
      <h3>Select a store to edit hours:</h3>
      
      <div className="store-grid">
        {STORE_LOCATIONS.map((store) => (
          <button 
            key={store.id}
            className="store-option-button"
            onClick={() => onSelectStore(store.id, store.name)}
          >
            <div className="store-name">{store.name}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StoreHoursSelector;